module.exports = __webpack_public_path__ + "static/img/11areaB_03.9cfbb66.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_03.png
// module id = 1092
// module chunks = 1